import React from "react";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { FaCalendarCheck } from "react-icons/fa6";


const NotificationDetailsComponent = () => {
  const location = useLocation();


  // Retrieve notification data from state
  const notification = location.state?.notification;

  // If no notification data is found, show an error message
  if (!notification) {
    return <h2>Notification Not Found</h2>;
  }

  return (
    <Card className="club-details-card">
      <Card.Body className="d-flex">
        {/* Club Image */}
        <div className="club-logo">
          <img src={notification.profilePic} alt={notification.username} className="club-image" />
        </div>

        {/* Club Info */}
        <div className="club-info">
          <div className="club-header">
            <h4 className="club-name">{notification.username}</h4>
            {/* <FaEllipsisH className="options-icon" /> */}
          </div>
          <p className="club-description">{notification.content}</p>

          <div className="club-meta-wraper">
            {/* Club Meta Info */}
            <div className="club-meta">
              <span><FaCalendarCheck />
                {notification?.date
                  ? `${new Date(notification.date).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                  })}`
                  : "Date not available"}
              </span>

            </div>

          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default NotificationDetailsComponent;
